export default "__VITE_ASSET__VLn2dqwi__"